import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { setNavStep } from '../app-main/actions/nav';
import ProfileForm from 'shared-components/flow-signup/profile-form';
import { FormattedMessage } from 'react-intl';

class SignupProfile extends Component {
  constructor (props) {
    super(props);
  }

  componentDidMount () {
    const { dispatch } = this.props;
    dispatch(setNavStep('Signup', 66));
  }

  render () {
    const { params = {}, profile = {} } = this.props;
    const referralId = params.referralId;
    const profileData = get(profile, 'data', {});
    const fbAvatarObject = get(profileData, 'social.facebook.picture.data');
    const fbAvatar = (
      fbAvatarObject &&
      !profileData.avatar_url &&
      !fbAvatarObject.is_silhouette
    ) ? fbAvatarObject.url : null;

    if (!profile.hasFetched) {
      return null;
    }

    return (
      <div className="SignupMain flex center container">
        <div className="signup-page-container">
          <div className="text-center">
            <h3>
              <FormattedMessage id='referrals.signup_profile.complete_profile' defaultMessage='Complete your profile' />
            </h3>
            <p>
              <FormattedMessage id='referrals.signup_profile.build_guests_hosts' defaultMessage='This helps build trust between guests and hosts.' />
            </p>
          </div>
          <ProfileForm
            prefilledData={{ ...profileData, ...(fbAvatar && { avatar: fbAvatar }) }}
            callbackFn={() => { window.location.href = `/referrals/${referralId}/verify`; }}
            source="guest referral"
            isSignupPage
          />
        </div>
      </div>
    );
  }
}

SignupProfile.propTypes = {
  dispatch: PropTypes.func,
  params: PropTypes.object,
  profile: PropTypes.object
};

const mapStateToProps = (state = {}) => {
  const profile = get(state, 'profile');

  return {
    profile
  };
};

export default connect(mapStateToProps)(SignupProfile);
